export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-secondary-50/50"></div>

      <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4"></div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-24 md:pt-28 pb-16 md:pb-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line text-base"></i>
              <span>热门视频聚合平台</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
              密桃视频
              <span className="block text-2xl md:text-3xl lg:text-4xl font-body font-medium text-foreground-600 mt-3">
                高清影视免费在线观看
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-6 max-w-xl mx-auto lg:mx-0">
              聚合红桃视频、樱桃视频、茄子视频、糖心视频等热门站点高清资源，
              涵盖最新电影、热播电视剧、综艺动漫等全品类内容。
              每日更新热门片单，免费全集在线观看不卡顿，为你打造一站式流畅观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mt-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">10万+</div>
                <div className="text-xs md:text-sm text-foreground-600 mt-1">高清片源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-600 mt-1">内容同步</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-500">全端畅看</div>
                <div className="text-xs md:text-sm text-foreground-600 mt-1">流畅不缓冲</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-8">
              <a
                href="#media"
                onClick={(e) => handleScroll(e, '#media')}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                立即观看
              </a>
              <a
                href="#features"
                onClick={(e) => handleScroll(e, '#features')}
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-background-300 text-foreground-800 font-semibold text-sm rounded-full hover:border-primary-400 hover:text-primary-500 transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                了解优势
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20watching%20scene%20on%20a%20modern%20tablet%20screen%20with%20film%20reel%20elements%2C%20soft%20warm%20lighting%20with%20golden%20and%20coral%20tones%2C%20minimal%20background%20with%20subtle%20gradient%2C%20elegant%20composition%2C%20entertainment%20platform%20aesthetic&width=960&height=720&seq=mitao-hero-main&orientation=landscape"
                alt="密桃视频在线观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                </div>
                <div className="flex-1">
                  <div className="h-1.5 bg-background-50/40 rounded-full">
                    <div className="h-full w-3/5 bg-primary-400 rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}